import type { ReactNode } from "react";

/**
 * Metaregel "a · b · c" (docs/UX-RICHTLIJNEN.md §6): lege onderdelen vallen weg, de regel breekt alleen
 * tussen onderdelen en begint nooit met een losse punt.
 */
export function Meta({ items, className = "" }: { items: ReactNode[]; className?: string }) {
  const parts = items.filter((i) => i !== null && i !== undefined && i !== false && i !== "");
  if (!parts.length) return null;
  return (
    <span className={`meta ${className}`.trim()}>
      {parts.map((p, i) => (
        <span key={i}>{p}</span>
      ))}
    </span>
  );
}
